<!--
 * @Author: zjw
 * @Date: 2021-05-18 15:56:22
 * @LastEditTime: 2022-09-16 17:58:09
 * @FilePath: \web-app\src\components\common\Content.vue
 * @Environment: Vue + Element
 * @Description: 主内容组件
-->
<template>
  <div class="content">
    <!-- 面包屑 -->
    <bread-crumb class="breadCrumb left"></bread-crumb>
    <!-- 主内容 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="main"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="main"></router-view>
  </div>
</template>

<script>
import breadCrumb from "./Breadcrumb.vue";
export default {
  name: "Content",
  components: {
    breadCrumb,
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.breadCrumb {
  /* display: block;
  width: 100%; */
  padding-bottom: 20px;
}
.main {
  /* margin-top: 20px; */
  flex: 1;
}
</style>
